import React from "react";
import "../css/pop-subj-sect.css";
import PopSubj from "../components/PopSubj.js";
import { ReactComponent as UpperDots } from "../assets/images/sect2-upper-dots.svg";

const PopSubjSect = () => {
  return (
    <section id="lp-sect-2">
      <div>
        <UpperDots id="upper-dots" className="abs" />
        <article>
          <h2>Popular subjects</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
        </article>
        <PopSubj />
        <button>View all subjects</button>
      </div>
    </section>
  );
};

export default PopSubjSect;
